import { Bank, Wirexfer } from '@wolfejs/icons/IconMap';
import type { BalanceInfo, FundMode } from '@wolfejs/ms-ui/Funds/types';

export const fundModes: FundMode[] = [
  {
    mode: 'ACH',
    icon: <Bank />,
    bankDetails: {
      accountName: 'Perfect Gift, LLC',
      bankName: 'PNC Bank, N.A.',
      bankAddress: '249 Fifth Avenue',
      city: 'Pittsburgh',
      state: 'PA',
      zip: '15222',
      accountNumber: '1069908257',
      routingNumber: '043000096',
      transferFee: 0,
    },
  },
  {
    mode: 'Wire',
    icon: <Wirexfer />,
    bankDetails: {
      accountName: 'Perfect Gift, LLC',
      bankName: 'PNC Bank, N.A.',
      bankAddress: '249 Fifth Avenue',
      city: 'Pittsburgh',
      state: 'PA',
      zip: '15222',
      accountNumber: '1234567890',
      routingNumber: '043000096',
      transferFee: 12,
    },
  },
];

export const balanceInfo: BalanceInfo = {
  balanceType: 'available',
  amount: 76940,
};
